export const STUDY_SUBJECTS = [
  ['english', 'English'],
  ['english-language', 'English Language'],
  ['english-literature', 'Literature'],
  ['english-as-an-additional-language', 'English as an Additional Language'],
  ['mathematics', 'Mathematics'],
  ['general-mathematics', 'General Mathematics'],
  ['mathematical-methods', 'Mathematical Methods'],
  ['specialist-mathematics', 'Specialist Mathematics'],
  ['science', 'Science'],
  ['biology', 'Biology'],
  ['chemistry', 'Chemistry'],
  ['physics', 'Physics'],
  ['psychology', 'Psychology'],
  ['humanities', 'Humanities and Social Sciences'],
  ['history', 'History'],
  ['geography', 'Geography'],
  ['economics', 'Economics'],
  ['business', 'Business'],
  ['accounting', 'Accounting'],
  ['legal-studies', 'Legal Studies'],
  ['politics', 'Politics'],
  ['digital-technologies', 'Digital Technologies'],
  ['computing', 'Computing'],
  ['design-and-technologies', 'Design and Technologies'],
  ['engineering', 'Engineering'],
  ['health-and-physical-education', 'Health and Physical Education'],
  ['food-studies', 'Food Studies'],
  ['visual-arts', 'Visual Arts'],
  ['media-arts', 'Media Arts'],
  ['music', 'Music'],
  ['drama', 'Drama'],
  ['dance', 'Dance'],
  ['languages', 'Languages'],
  ['religion-and-ethics', 'Religion and Ethics'],
  ['vocational-education', 'Vocational Education and Training'],
] as const;

export const AU_JURISDICTIONS = [
  ['ACT', 'Australian Capital Territory'],
  ['NSW', 'New South Wales'],
  ['NT', 'Northern Territory'],
  ['QLD', 'Queensland'],
  ['SA', 'South Australia'],
  ['TAS', 'Tasmania'],
  ['VIC', 'Victoria'],
  ['WA', 'Western Australia'],
] as const;
